import i18next from "i18next";
import { validationMessageTranslationsK } from "src/translation-hooks/validation-message-translations";

export const hasToBeEqualTo = (otherField: string) => i18next.getFixedT(i18next.language)(validationMessageTranslationsK.hasToBeEqualTo, { otherField });

export const hasToBeLowerTo = (otherField1: string, otherField2: string) => i18next.getFixedT(i18next.language)(validationMessageTranslationsK.hasToBeLowerTo, { otherField1, otherField2 });
export const hasToBeLowerOrEqualTo = (otherField1: string, otherField2: string) =>
  i18next.getFixedT(i18next.language)(validationMessageTranslationsK.hasToBeLowerOrEqualTo, { otherField1, otherField2 });

export const hasToBetween = () => i18next.getFixedT(i18next.language)(validationMessageTranslationsK.hasToBetween);

export const hasToNotExceedLimit = () => i18next.getFixedT(i18next.language)(validationMessageTranslationsK.hasToNotExceedLimit);

export const passwordRequirements = () => i18next.getFixedT(i18next.language)(validationMessageTranslationsK.passwordRequirements);
